import { DEFAULT_STRENGTH_SET } from "../domain/strength/constants";
import { DEFAULT_WOD_MOVEMENT } from "../domain/wod/constants";
import { DEFAULT_RUNNING_SEGMENT } from "../domain/running/constants";

export const SYSTEM_TEMPLATES = [
    // ═══════════════════════════════════════════════════════════════
    // NATAÇÃO (9 Modelos: 4 originais + 5 novos premium)
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'sys_swim_1',
        title: 'Natação: Iniciante (Adaptação)',
        workoutType: 'swimming',
        isSingleDay: false,
        weeklyFrequency: 2,
        totalWeeks: 4,
        workouts: [
            {
                name: 'Treino A',
                blocks: [
                    { name: 'Aquecimento', sets: [{ reps: 4, distance: 25, style: 'Livre', intensity: 'Leve', interval: '30s', description: 'Pernada com prancha' }] },
                    { name: 'Principal', sets: [{ reps: 6, distance: 50, style: 'Crawl', intensity: 'Moderado', interval: '45s', description: 'Respiração 3/1' }] },
                    { name: 'Soltura', sets: [{ reps: 1, distance: 100, style: 'Livre', intensity: 'Leve', interval: '', description: 'Solto' }] }
                ]
            }
        ]
    },
    {
        id: 'sys_swim_2',
        title: 'Natação: Intermediário',
        workoutType: 'swimming',
        isSingleDay: false,
        weeklyFrequency: 3,
        totalWeeks: 4,
        workouts: [
            {
                name: 'Treino A - Resistência',
                blocks: [
                    { name: 'Aquecimento', sets: [{ reps: 1, distance: 200, style: 'Livre', intensity: 'Leve', interval: '', description: 'Aquecimento livre' }] },
                    { name: 'Principal', sets: [{ reps: 4, distance: 100, style: 'Crawl', intensity: 'A2', interval: '20s', description: 'Ritmo constante' }, { reps: 8, distance: 50, style: 'Crawl', intensity: 'A3', interval: '15s', description: 'Forte' }] },
                    { name: 'Soltura', sets: [{ reps: 1, distance: 200, style: 'Costas', intensity: 'Leve', interval: '', description: 'Recuperação' }] }
                ]
            }
        ]
    },
    {
        id: 'sys_swim_3',
        title: 'Natação: Velocidade (Sprints)',
        workoutType: 'swimming',
        isSingleDay: false,
        weeklyFrequency: 2,
        totalWeeks: 4,
        workouts: [
            {
                name: 'Treino A - Tiros',
                blocks: [
                    { name: 'Aquecimento', sets: [{ reps: 1, distance: 400, style: 'Medley', intensity: 'Leve', interval: '', description: '100m de cada' }] },
                    { name: 'Velocidade', sets: [{ reps: 8, distance: 25, style: 'Crawl', intensity: 'Máximo', interval: '45s', description: 'Explosão total' }] },
                    { name: 'Soltura', sets: [{ reps: 1, distance: 100, style: 'Livre', intensity: 'Leve', interval: '', description: '' }] }
                ]
            }
        ]
    },
    {
        id: 'sys_swim_4',
        title: 'Natação: Longão',
        workoutType: 'swimming',
        isSingleDay: false,
        weeklyFrequency: 1,
        totalWeeks: 4,
        workouts: [
            {
                name: 'Treino Único',
                blocks: [
                    { name: 'Principal', sets: [{ reps: 1, distance: 1500, style: 'Crawl', intensity: 'A1', interval: '', description: 'Contínuo sem parar' }] }
                ]
            }
        ]
    },
    // ── 5 NOVOS MODELOS PREMIUM DE NATAÇÃO ──
    {
        id: 'sys_swim_5',
        title: 'Natação: Técnica de Crawl com Educativos',
        workoutType: 'swimming',
        isSingleDay: false,
        weeklyFrequency: 3,
        totalWeeks: 6,
        workouts: [
            {
                name: 'Treino Técnico A',
                blocks: [
                    { name: 'Aquecimento', sets: [
                        { reps: 1, distance: 200, style: 'Livre', intensity: 'Leve', interval: '', description: 'Nado solto' },
                        { reps: 4, distance: 50, style: 'Perna', intensity: 'Leve', interval: '15s', equipment: 'Prancha', description: 'Pernada crawl' }
                    ]},
                    { name: 'Educativo', sets: [
                        { reps: 4, distance: 50, style: 'Educativo', intensity: 'Moderado', interval: '20s', technicalFocus: 'Catchup drill', description: 'Toque na mão antes de iniciar a braçada' },
                        { reps: 4, distance: 50, style: 'Educativo', intensity: 'Moderado', interval: '20s', technicalFocus: 'Fingertip drag', description: 'Arrastar a ponta dos dedos na superfície durante a recuperação' },
                        { reps: 4, distance: 25, style: 'Educativo', intensity: 'Leve', interval: '15s', technicalFocus: 'Nado punho fechado', description: 'Consciência do antebraço na propulsão' }
                    ]},
                    { name: 'Principal', sets: [
                        { reps: 6, distance: 100, style: 'Crawl', intensity: 'A2', interval: '20s', technicalFocus: 'Aplicar educativos', description: 'Foco na aplicação dos drills ao nado completo' }
                    ]},
                    { name: 'Soltura', sets: [
                        { reps: 1, distance: 200, style: 'Costas', intensity: 'Leve', interval: '', description: 'Relaxar ombros' }
                    ]}
                ]
            }
        ]
    },
    {
        id: 'sys_swim_6',
        title: 'Natação: Preparatório Triathlon (Águas Abertas)',
        workoutType: 'swimming',
        isSingleDay: false,
        weeklyFrequency: 3,
        totalWeeks: 12,
        workouts: [
            {
                name: 'Treino A - Resistência de Base',
                blocks: [
                    { name: 'Aquecimento', sets: [
                        { reps: 1, distance: 400, style: 'Livre', intensity: 'A1', interval: '', description: '200 crawl + 100 costas + 100 perna' }
                    ]},
                    { name: 'Principal', sets: [
                        { reps: 5, distance: 200, style: 'Crawl', intensity: 'A2', interval: '30s', description: 'Simulação ritmo de prova de triathlon' },
                        { reps: 4, distance: 100, style: 'Crawl', intensity: 'A3', interval: '20s', technicalFocus: 'Respiração bilateral', description: 'Alternar respiração 3/5 tempos' }
                    ]},
                    { name: 'Soltura', sets: [
                        { reps: 1, distance: 200, style: 'Costas', intensity: 'Leve', interval: '', description: 'Soltura ativa' }
                    ]}
                ]
            },
            {
                name: 'Treino B - Ritmo e Orientação',
                blocks: [
                    { name: 'Aquecimento', sets: [
                        { reps: 1, distance: 300, style: 'Livre', intensity: 'A1', interval: '', description: 'Variando estilos' }
                    ]},
                    { name: 'Principal', sets: [
                        { reps: 3, distance: 400, style: 'Crawl', intensity: 'A2', interval: '45s', technicalFocus: 'Sighting drill', description: 'A cada 10 braçadas, levantar a cabeça para orientação' },
                        { reps: 6, distance: 50, style: 'Crawl', intensity: 'A3', interval: '15s', equipment: 'Palmar', description: 'Força de braçada' }
                    ]},
                    { name: 'Soltura', sets: [
                        { reps: 1, distance: 100, style: 'Costas', intensity: 'Leve', interval: '', description: 'Recuperação' }
                    ]}
                ]
            }
        ]
    },
    {
        id: 'sys_swim_7',
        title: 'Natação: Medley Completo (4 Estilos)',
        workoutType: 'swimming',
        isSingleDay: false,
        weeklyFrequency: 4,
        totalWeeks: 8,
        workouts: [
            {
                name: 'Treino Medley',
                blocks: [
                    { name: 'Aquecimento', sets: [
                        { reps: 1, distance: 400, style: 'Medley', intensity: 'A1', interval: '', description: '100m de cada estilo na ordem oficial' }
                    ]},
                    { name: 'Técnica', sets: [
                        { reps: 4, distance: 50, style: 'Borboleta', intensity: 'Moderado', interval: '20s', technicalFocus: 'Ondulação do corpo', description: 'Foco no corpo inteiro, não só nos braços' },
                        { reps: 4, distance: 50, style: 'Costas', intensity: 'Moderado', interval: '15s', technicalFocus: 'Rotação de quadril', description: 'Manter rotação contínua de quadril' },
                        { reps: 4, distance: 50, style: 'Peito', intensity: 'Moderado', interval: '20s', technicalFocus: 'Timing pernada', description: 'Sincronizar glide com a puxada' }
                    ]},
                    { name: 'Principal', sets: [
                        { reps: 4, distance: 100, style: 'Medley', intensity: 'A2', interval: '30s', description: '25m de cada estilo dentro de cada 100m' },
                        { reps: 8, distance: 50, style: 'Crawl', intensity: 'A3', interval: '15s', description: 'Ritmo forte para fechar' }
                    ]},
                    { name: 'Soltura', sets: [
                        { reps: 1, distance: 200, style: 'Livre', intensity: 'Leve', interval: '', description: 'Escolha livre' }
                    ]}
                ]
            }
        ]
    },
    {
        id: 'sys_swim_8',
        title: 'Natação: Potência com Materiais',
        workoutType: 'swimming',
        isSingleDay: false,
        weeklyFrequency: 3,
        totalWeeks: 6,
        workouts: [
            {
                name: 'Treino de Força Aquática',
                blocks: [
                    { name: 'Aquecimento', sets: [
                        { reps: 1, distance: 300, style: 'Livre', intensity: 'A1', interval: '', description: 'Variado solto' }
                    ]},
                    { name: 'Principal', sets: [
                        { reps: 6, distance: 100, style: 'Crawl', intensity: 'A2', interval: '20s', equipment: 'Palmar', description: 'Braçada com palmar para potência' },
                        { reps: 6, distance: 50, style: 'Crawl', intensity: 'A3', interval: '15s', equipment: 'Pull buoy', description: 'Isolamento de braço com flutuador' },
                        { reps: 4, distance: 50, style: 'Perna', intensity: 'A2', interval: '20s', equipment: 'Nadadeira', description: 'Pernada de crawl com nadadeira' },
                        { reps: 4, distance: 50, style: 'Crawl', intensity: 'VO2', interval: '30s', equipment: 'Paraquedas', description: 'Sprint com resistência máxima' }
                    ]},
                    { name: 'Soltura', sets: [
                        { reps: 1, distance: 200, style: 'Costas', intensity: 'Leve', interval: '', description: 'Sem material' }
                    ]}
                ]
            }
        ]
    },
    {
        id: 'sys_swim_9',
        title: 'Natação: VO2max e Tiros Curtos',
        workoutType: 'swimming',
        isSingleDay: false,
        weeklyFrequency: 3,
        totalWeeks: 8,
        workouts: [
            {
                name: 'Treino VO2 / Anaeróbico',
                blocks: [
                    { name: 'Aquecimento', sets: [
                        { reps: 1, distance: 300, style: 'Livre', intensity: 'A1', interval: '', description: '100 crawl + 100 costas + 100 perna' },
                        { reps: 4, distance: 50, style: 'Crawl', intensity: 'A2', interval: '10s', description: 'Progressivo dentro de cada 50m' }
                    ]},
                    { name: 'Principal', sets: [
                        { reps: 8, distance: 50, style: 'Crawl', intensity: 'VO2', interval: '40s', description: 'Máximo esforço controlado em cada tiro' },
                        { reps: 4, distance: 25, style: 'Crawl', intensity: 'Máximo', interval: '60s', description: 'Sprint puro — saída de borda' }
                    ]},
                    { name: 'Velocidade', sets: [
                        { reps: 4, distance: 25, style: 'Borboleta', intensity: 'Máximo', interval: '45s', description: 'Tiro de velocidade borboleta' }
                    ]},
                    { name: 'Soltura', sets: [
                        { reps: 1, distance: 200, style: 'Costas', intensity: 'Leve', interval: '', description: 'Recuperação completa' }
                    ]}
                ]
            }
        ]
    },

    // ═══════════════════════════════════════════════════════════════
    // MUSCULAÇÃO (9 Modelos: 4 originais + 5 novos premium)
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'sys_strength_1',
        title: 'Musculação: Full Body Iniciante',
        workoutType: 'strength',
        isSingleDay: false,
        weeklyFrequency: 3,
        totalWeeks: 4,
        workouts: [
            {
                name: 'Treino Único',
                blocks: [
                    { name: 'Aquecimento', sets: [{ sets: 1, reps: 10, exercise: 'Esteira', load: 'Leve', rest: '', muscleGroup: 'Pernas' }] },
                    { name: 'Principal', sets: [
                        { sets: 3, reps: 15, exercise: 'Leg Press', load: 'Leve', rest: '60s', muscleGroup: 'Quadríceps' },
                        { sets: 3, reps: 15, exercise: 'Puxada Frontal', load: 'Leve', rest: '60s', muscleGroup: 'Costas' },
                        { sets: 3, reps: 15, exercise: 'Supino Máquina', load: 'Leve', rest: '60s', muscleGroup: 'Peito' },
                        { sets: 3, reps: 15, exercise: 'Abdominal', load: '', rest: '45s', muscleGroup: 'Abdômen' }
                    ] }
                ]
            }
        ]
    },
    {
        id: 'sys_strength_2',
        title: 'Musculação: Hipertrofia A/B/C',
        workoutType: 'strength',
        isSingleDay: false,
        weeklyFrequency: 5,
        totalWeeks: 8,
        workouts: [
            {
                name: 'Treino A - Peito e Tríceps',
                blocks: [{ name: 'Principal', sets: [
                    { sets: 4, reps: 10, exercise: 'Supino Reto', load: 'Pesado', rest: '90s', muscleGroup: 'Peito' },
                    { sets: 3, reps: 12, exercise: 'Crucifixo', load: 'Moderado', rest: '60s', muscleGroup: 'Peito' },
                    { sets: 4, reps: 12, exercise: 'Tríceps Polia', load: 'Moderado', rest: '60s', muscleGroup: 'Tríceps' }
                ]}]
            },
            {
                name: 'Treino B - Costas e Bíceps',
                blocks: [{ name: 'Principal', sets: [
                    { sets: 4, reps: 10, exercise: 'Puxada Alta', load: 'Pesado', rest: '90s', muscleGroup: 'Costas' },
                    { sets: 3, reps: 12, exercise: 'Remada Baixa', load: 'Moderado', rest: '60s', muscleGroup: 'Costas' },
                    { sets: 4, reps: 12, exercise: 'Rosca Direta', load: 'Moderado', rest: '60s', muscleGroup: 'Bíceps' }
                ]}]
            },
            {
                name: 'Treino C - Pernas e Ombros',
                blocks: [{ name: 'Principal', sets: [
                    { sets: 4, reps: 12, exercise: 'Agachamento Livre', load: 'Pesado', rest: '120s', muscleGroup: 'Pernas' },
                    { sets: 3, reps: 15, exercise: 'Cadeira Extensora', load: 'Moderado', rest: '60s', muscleGroup: 'Pernas' },
                    { sets: 4, reps: 12, exercise: 'Desenvolvimento', load: 'Moderado', rest: '60s', muscleGroup: 'Ombros' }
                ]}]
            }
        ]
    },
    {
        id: 'sys_strength_3',
        title: 'Musculação: Emagrecimento (Circuito)',
        workoutType: 'strength',
        isSingleDay: false,
        weeklyFrequency: 3,
        totalWeeks: 4,
        workouts: [
            {
                name: 'Circuito Metabólico',
                blocks: [{ name: 'Circuito 4x', sets: [
                    { sets: 1, reps: 20, exercise: 'Agachamento com Salto', load: '', rest: '0s', muscleGroup: 'Pernas' },
                    { sets: 1, reps: 15, exercise: 'Flexão de Braço', load: '', rest: '0s', muscleGroup: 'Peito' },
                    { sets: 1, reps: 20, exercise: 'Abdominal Remador', load: '', rest: '0s', muscleGroup: 'Abdômen' },
                    { sets: 1, reps: 60, exercise: 'Polichinelo', load: '', rest: '60s', muscleGroup: 'Cardio' }
                ]}]
            }
        ]
    },
    {
        id: 'sys_strength_4',
        title: 'Musculação: Força Máxima (5x5)',
        workoutType: 'strength',
        isSingleDay: false,
        weeklyFrequency: 3,
        totalWeeks: 8,
        workouts: [
            {
                name: 'Treino A',
                blocks: [{ name: 'Base', sets: [
                    { sets: 5, reps: 5, exercise: 'Agachamento Livre', load: 'Máximo', rest: '180s', muscleGroup: 'Pernas' },
                    { sets: 5, reps: 5, exercise: 'Supino Reto', load: 'Máximo', rest: '180s', muscleGroup: 'Peito' },
                    { sets: 5, reps: 5, exercise: 'Remada Curvada', load: 'Máximo', rest: '180s', muscleGroup: 'Costas' }
                ]}]
            }
        ]
    },
    // ── 5 NOVOS MODELOS PREMIUM DE MUSCULAÇÃO ──
    {
        id: 'sys_strength_5',
        title: 'Musculação: Push/Pull/Legs (Intermediário)',
        workoutType: 'strength',
        isSingleDay: false,
        weeklyFrequency: 6,
        totalWeeks: 8,
        workouts: [
            {
                name: 'Push - Peito, Ombro e Tríceps',
                blocks: [
                    { name: 'Aquecimento', sets: [
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Rotação de ombro com elástico', sets: 2, reps: '15', load: '', rest: '', muscleGroup: 'Ombros', equipment: 'Elástico' }
                    ]},
                    { name: 'Principal', sets: [
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Supino Reto com Barra', sets: 4, reps: '8-10', load: 'Pesado', rest: '90s', muscleGroup: 'Peito', equipment: 'Barra', tempo: '3-1-1-0' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Supino Inclinado Halteres', sets: 3, reps: '10-12', load: 'Moderado', rest: '75s', muscleGroup: 'Peito', equipment: 'Halteres' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Desenvolvimento Arnold', sets: 3, reps: '10-12', load: 'Moderado', rest: '60s', muscleGroup: 'Ombros', equipment: 'Halteres' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Elevação Lateral', sets: 3, reps: '15', load: 'Leve', rest: '45s', muscleGroup: 'Deltóide', equipment: 'Halteres', strengthMethod: 'dropset', description: 'Na última série, fazer drop set reduzindo 30% da carga' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Tríceps Corda', sets: 3, reps: '12-15', load: 'Moderado', rest: '45s', muscleGroup: 'Tríceps', equipment: 'Cabo' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Tríceps Francês', sets: 3, reps: '12', load: 'Moderado', rest: '45s', muscleGroup: 'Tríceps', equipment: 'Halteres' }
                    ]}
                ]
            },
            {
                name: 'Pull - Costas e Bíceps',
                blocks: [
                    { name: 'Principal', sets: [
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Puxada Pronada', sets: 4, reps: '8-10', load: 'Pesado', rest: '90s', muscleGroup: 'Costas', equipment: 'Cabo', tempo: '3-1-2-0' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Remada Curvada', sets: 4, reps: '10', load: 'Pesado', rest: '90s', muscleGroup: 'Costas', equipment: 'Barra' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Remada Unilateral', sets: 3, reps: '12', load: 'Moderado', rest: '60s', muscleGroup: 'Costas', equipment: 'Halteres' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Face Pull', sets: 3, reps: '15', load: 'Leve', rest: '45s', muscleGroup: 'Trapézio', equipment: 'Cabo' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Rosca Direta', sets: 3, reps: '10-12', load: 'Moderado', rest: '60s', muscleGroup: 'Bíceps', equipment: 'Barra' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Rosca Martelo', sets: 3, reps: '12', load: 'Moderado', rest: '45s', muscleGroup: 'Bíceps', equipment: 'Halteres' }
                    ]}
                ]
            },
            {
                name: 'Legs - Pernas Completo',
                blocks: [
                    { name: 'Principal', sets: [
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Agachamento Livre', sets: 4, reps: '8-10', load: 'Pesado', rest: '120s', muscleGroup: 'Quadríceps', equipment: 'Barra', tempo: '3-1-1-0' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Leg Press 45°', sets: 4, reps: '12', load: 'Pesado', rest: '90s', muscleGroup: 'Quadríceps', equipment: 'Máquina' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Stiff', sets: 4, reps: '10-12', load: 'Moderado', rest: '90s', muscleGroup: 'Posterior', equipment: 'Barra' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Cadeira Extensora', sets: 3, reps: '15', load: 'Moderado', rest: '60s', muscleGroup: 'Quadríceps', equipment: 'Máquina', strengthMethod: 'dropset', description: 'Drop set na última série' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Mesa Flexora', sets: 3, reps: '12', load: 'Moderado', rest: '60s', muscleGroup: 'Posterior', equipment: 'Máquina' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Panturrilha em Pé', sets: 4, reps: '15-20', load: 'Moderado', rest: '45s', muscleGroup: 'Panturrilha', equipment: 'Máquina' }
                    ]}
                ]
            }
        ]
    },
    {
        id: 'sys_strength_6',
        title: 'Musculação: Upper/Lower com Cadência',
        workoutType: 'strength',
        isSingleDay: false,
        weeklyFrequency: 4,
        totalWeeks: 8,
        workouts: [
            {
                name: 'Upper A - Força',
                blocks: [
                    { name: 'Principal', sets: [
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Supino Reto', sets: 4, reps: '6-8', load: 'Pesado', rest: '120s', muscleGroup: 'Peito', equipment: 'Barra', tempo: '4-1-1-0', instructions: 'Manter escápulas retraídas, descer a barra até 2 dedos do peito' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Remada Curvada', sets: 4, reps: '6-8', load: 'Pesado', rest: '120s', muscleGroup: 'Costas', equipment: 'Barra', tempo: '3-1-2-1' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Desenvolvimento Militar', sets: 3, reps: '8-10', load: 'Moderado', rest: '90s', muscleGroup: 'Ombros', equipment: 'Barra', tempo: '3-0-1-0' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Rosca Direta', sets: 3, reps: '10', load: 'Moderado', rest: '60s', muscleGroup: 'Bíceps', equipment: 'Barra' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Tríceps Testa', sets: 3, reps: '10', load: 'Moderado', rest: '60s', muscleGroup: 'Tríceps', equipment: 'Barra' }
                    ]}
                ]
            },
            {
                name: 'Lower A - Força',
                blocks: [
                    { name: 'Principal', sets: [
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Agachamento Livre', sets: 5, reps: '5', load: 'Pesado', rest: '180s', muscleGroup: 'Quadríceps', equipment: 'Barra', tempo: '3-1-1-0', instructions: 'Profundidade abaixo do paralelo, joelhos alinhados com os pés' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Terra Convencional', sets: 4, reps: '5-6', load: 'Pesado', rest: '180s', muscleGroup: 'Posterior', equipment: 'Barra', tempo: '2-0-1-1' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Búlgaro', sets: 3, reps: '10', load: 'Moderado', rest: '90s', muscleGroup: 'Glúteos', equipment: 'Halteres' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Cadeira Extensora', sets: 3, reps: '12-15', load: 'Moderado', rest: '60s', muscleGroup: 'Quadríceps', equipment: 'Máquina' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Panturrilha Sentado', sets: 4, reps: '15', load: 'Moderado', rest: '45s', muscleGroup: 'Panturrilha', equipment: 'Máquina', tempo: '2-2-1-0' }
                    ]}
                ]
            }
        ]
    },
    {
        id: 'sys_strength_7',
        title: 'Musculação: Hipertrofia Avançada (Drop Set + Pirâmide)',
        workoutType: 'strength',
        isSingleDay: false,
        weeklyFrequency: 5,
        totalWeeks: 8,
        workouts: [
            {
                name: 'Peito e Tríceps - Choque',
                blocks: [
                    { name: 'Principal', sets: [
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Supino Reto', sets: 4, reps: '12-10-8-6', load: 'Progressivo', rest: '90s', muscleGroup: 'Peito', equipment: 'Barra', strengthMethod: 'pyramid_asc', description: 'Pirâmide crescente: aumentar carga a cada série' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Supino Inclinado', sets: 4, reps: '10', load: 'Moderado', rest: '75s', muscleGroup: 'Peito', equipment: 'Halteres' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Cross Over', sets: 3, reps: '15', load: 'Moderado', rest: '60s', muscleGroup: 'Peito', equipment: 'Cabo', strengthMethod: 'dropset', description: 'Drop set: 3 quedas de 20% na última série' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Tríceps Polia', sets: 4, reps: '12', load: 'Moderado', rest: '45s', muscleGroup: 'Tríceps', equipment: 'Cabo', strengthMethod: 'restpause', description: 'Rest-pause: falha + 10s pausa + máximo de reps' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Mergulho em Paralelas', sets: 3, reps: '10-12', load: 'Peso Corporal', rest: '60s', muscleGroup: 'Tríceps', equipment: 'Peso Corporal' }
                    ]}
                ]
            },
            {
                name: 'Costas e Bíceps - Choque',
                blocks: [
                    { name: 'Principal', sets: [
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Barra Fixa', sets: 4, reps: '8-10', load: 'Peso Corporal', rest: '90s', muscleGroup: 'Costas', equipment: 'Peso Corporal', instructions: 'Se conseguir mais de 10, adicionar carga com cinturão' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Remada Cavalinho', sets: 4, reps: '10', load: 'Pesado', rest: '90s', muscleGroup: 'Costas', equipment: 'Máquina' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Pullover', sets: 3, reps: '12', load: 'Moderado', rest: '60s', muscleGroup: 'Costas', equipment: 'Halteres' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Rosca Scott', sets: 3, reps: '12-10-8', load: 'Progressivo', rest: '60s', muscleGroup: 'Bíceps', equipment: 'Barra', strengthMethod: 'pyramid_asc' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Rosca Concentrada', sets: 3, reps: '12', load: 'Moderado', rest: '45s', muscleGroup: 'Bíceps', equipment: 'Halteres', strengthMethod: 'dropset', description: 'Drop set na última série' }
                    ]}
                ]
            },
            {
                name: 'Pernas - Choque',
                blocks: [
                    { name: 'Principal', sets: [
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Agachamento Livre', sets: 5, reps: '10-8-6-6-8', load: 'Progressivo', rest: '120s', muscleGroup: 'Quadríceps', equipment: 'Barra', strengthMethod: 'pyramid_asc', description: 'Pirâmide: subir carga até a 4ª série, voltar na 5ª' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Leg Press', sets: 4, reps: '12', load: 'Pesado', rest: '90s', muscleGroup: 'Quadríceps', equipment: 'Máquina', strengthMethod: 'dropset', description: 'Drop set triplo na última série' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Stiff', sets: 4, reps: '10', load: 'Moderado', rest: '90s', muscleGroup: 'Posterior', equipment: 'Barra' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Cadeira Extensora', sets: 3, reps: '15', load: 'Moderado', rest: '60s', muscleGroup: 'Quadríceps', equipment: 'Máquina' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Mesa Flexora', sets: 3, reps: '12', load: 'Moderado', rest: '60s', muscleGroup: 'Posterior', equipment: 'Máquina', strengthMethod: 'restpause' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Panturrilha Gêmeos', sets: 5, reps: '20', load: 'Moderado', rest: '30s', muscleGroup: 'Panturrilha', equipment: 'Máquina' }
                    ]}
                ]
            }
        ]
    },
    {
        id: 'sys_strength_8',
        title: 'Musculação: Funcional com Kettlebell e TRX',
        workoutType: 'strength',
        isSingleDay: false,
        weeklyFrequency: 3,
        totalWeeks: 6,
        workouts: [
            {
                name: 'Treino Funcional A',
                blocks: [
                    { name: 'Aquecimento', sets: [
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Mobilidade de quadril', sets: 1, reps: '10', load: '', rest: '', muscleGroup: 'Core', equipment: 'Peso Corporal' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Prancha frontal', sets: 2, reps: '30s', load: '', rest: '15s', muscleGroup: 'Core', equipment: 'Peso Corporal' }
                    ]},
                    { name: 'Principal', sets: [
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Swing Russo', sets: 4, reps: '15', load: '16-24 kg', rest: '60s', muscleGroup: 'Posterior', equipment: 'Kettlebell', instructions: 'Explosão de quadril, braços relaxados. O KB deve chegar à altura dos ombros.' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Goblet Squat', sets: 4, reps: '12', load: '16-20 kg', rest: '60s', muscleGroup: 'Quadríceps', equipment: 'Kettlebell' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Remada TRX', sets: 3, reps: '12-15', load: 'Peso Corporal', rest: '45s', muscleGroup: 'Costas', equipment: 'TRX', instructions: 'Quanto mais horizontal o corpo, mais difícil' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Flexão no TRX', sets: 3, reps: '10-12', load: 'Peso Corporal', rest: '45s', muscleGroup: 'Peito', equipment: 'TRX' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Turkish Get-Up', sets: 3, reps: '3 (cada lado)', load: '12-16 kg', rest: '90s', muscleGroup: 'Full Body', equipment: 'Kettlebell', instructions: 'Movimento completo e controlado. Manter olhos no KB.' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Prancha com Puxada', sets: 3, reps: '10 (cada lado)', load: '8-12 kg', rest: '45s', muscleGroup: 'Core', equipment: 'Kettlebell' }
                    ]}
                ]
            }
        ]
    },
    {
        id: 'sys_strength_9',
        title: 'Musculação: Reabilitação e Mobilidade (Retorno)',
        workoutType: 'strength',
        isSingleDay: false,
        weeklyFrequency: 3,
        totalWeeks: 6,
        workouts: [
            {
                name: 'Treino de Retorno',
                blocks: [
                    { name: 'Aquecimento', sets: [
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Bicicleta ergométrica', sets: 1, reps: '10 min', load: 'Leve', rest: '', muscleGroup: 'Full Body', equipment: 'Máquina', instructions: 'RPM baixo, sem resistência. Apenas aquecer articulações.' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Mobilidade de tornozelo', sets: 2, reps: '10 (cada)', load: '', rest: '', muscleGroup: 'Panturrilha', equipment: 'Peso Corporal' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Ativação de glúteo com elástico', sets: 2, reps: '15', load: 'Leve', rest: '', muscleGroup: 'Glúteos', equipment: 'Elástico' }
                    ]},
                    { name: 'Principal', sets: [
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Agachamento no Smith', sets: 3, reps: '12-15', load: 'Leve', rest: '60s', muscleGroup: 'Quadríceps', equipment: 'Smith', tempo: '3-1-2-0', instructions: 'Amplitude controlada, sem dor. Priorizar controle excêntrico.' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Puxada no Graviton', sets: 3, reps: '12', load: 'Assistido', rest: '60s', muscleGroup: 'Costas', equipment: 'Máquina' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Supino Máquina', sets: 3, reps: '12', load: 'Leve', rest: '60s', muscleGroup: 'Peito', equipment: 'Máquina', tempo: '3-1-1-0' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Elevação Lateral', sets: 2, reps: '15', load: 'Leve', rest: '45s', muscleGroup: 'Ombros', equipment: 'Halteres' },
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Prancha frontal', sets: 3, reps: '20-30s', load: '', rest: '30s', muscleGroup: 'Core', equipment: 'Peso Corporal' }
                    ]},
                    { name: 'Alongamento', sets: [
                        { ...DEFAULT_STRENGTH_SET, exercise: 'Alongamento estático geral', sets: 1, reps: '30s cada grupo', load: '', rest: '', muscleGroup: 'Full Body', equipment: 'Peso Corporal', instructions: 'Manter cada posição por 30s sem forçar. Respiração profunda.' }
                    ]}
                ]
            }
        ]
    },

    // ═══════════════════════════════════════════════════════════════
    // WOD (4 Modelos originais + 5 novos premium)
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'sys_wod_1',
        title: 'WOD: Cindy (Ginástico)',
        workoutType: 'wod',
        isSingleDay: true,
        weeklyFrequency: 1,
        totalWeeks: 1,
        workouts: [
            {
                name: 'AMRAP 20 Min',
                blocks: [{ name: 'WOD', workoutType: 'wod', componentType: 'metcon', format: 'amrap', scoreType: 'rounds_reps', timeCap: '20 min', stimulus: 'Ritmo sustentável e transições curtas.', sets: [
                    { ...DEFAULT_WOD_MOVEMENT, movementId: 'pull_up', movement: 'Pull-up', category: 'gymnastics', reps: 5, unit: 'reps', notes: 'Barra' },
                    { ...DEFAULT_WOD_MOVEMENT, movementId: 'push_up', movement: 'Push-up', category: 'bodyweight', reps: 10, unit: 'reps', notes: 'Flexão' },
                    { ...DEFAULT_WOD_MOVEMENT, movementId: 'air_squat', movement: 'Air Squat', category: 'bodyweight', reps: 15, unit: 'reps', notes: 'Agachamento livre' }
                ]}]
            }
        ]
    },
    {
        id: 'sys_wod_2',
        title: 'WOD: Fran (LPO + Ginástico)',
        workoutType: 'wod',
        isSingleDay: true,
        weeklyFrequency: 1,
        totalWeeks: 1,
        workouts: [
            {
                name: 'For Time 21-15-9',
                blocks: [{ name: 'WOD', workoutType: 'wod', componentType: 'metcon', format: 'for_time', scoreType: 'time', timeCap: '10 min', stimulus: 'Alta intensidade com carga moderada.', sets: [
                    { ...DEFAULT_WOD_MOVEMENT, movementId: 'thruster', movement: 'Thruster', category: 'weightlifting', reps: '21-15-9', unit: 'reps', load: '95/65 lb' },
                    { ...DEFAULT_WOD_MOVEMENT, movementId: 'pull_up', movement: 'Pull-up', category: 'gymnastics', reps: '21-15-9', unit: 'reps' }
                ]}]
            }
        ]
    },
    {
        id: 'sys_wod_3',
        title: 'WOD: Murph (Hero WOD)',
        workoutType: 'wod',
        isSingleDay: true,
        weeklyFrequency: 1,
        totalWeeks: 1,
        workouts: [
            {
                name: 'For Time (com Colete)',
                blocks: [{ name: 'WOD', workoutType: 'wod', componentType: 'metcon', format: 'chipper', scoreType: 'time', timeCap: '60 min', stimulus: 'WOD longo de resistência muscular e cardiovascular.', scalingNotes: 'Particionar reps ou reduzir volume conforme nível.', sets: [
                    { ...DEFAULT_WOD_MOVEMENT, movementId: 'run', movement: 'Corrida', category: 'monostructural', reps: 1600, unit: 'm' },
                    { ...DEFAULT_WOD_MOVEMENT, movementId: 'pull_up', movement: 'Pull-up', category: 'gymnastics', reps: 100, unit: 'reps' },
                    { ...DEFAULT_WOD_MOVEMENT, movementId: 'push_up', movement: 'Push-up', category: 'bodyweight', reps: 200, unit: 'reps' },
                    { ...DEFAULT_WOD_MOVEMENT, movementId: 'air_squat', movement: 'Air Squat', category: 'bodyweight', reps: 300, unit: 'reps' },
                    { ...DEFAULT_WOD_MOVEMENT, movementId: 'run', movement: 'Corrida', category: 'monostructural', reps: 1600, unit: 'm' }
                ]}]
            }
        ]
    },
    {
        id: 'sys_wod_4',
        title: 'WOD: EMOM 10 Min (Cardio/Força)',
        workoutType: 'wod',
        isSingleDay: true,
        weeklyFrequency: 1,
        totalWeeks: 1,
        workouts: [
            {
                name: 'EMOM',
                blocks: [{ name: 'WOD', workoutType: 'wod', componentType: 'metcon', format: 'emom', scoreType: 'completion', timeCap: '10 min', stimulus: 'Manter trabalho consistente dentro de cada minuto.', sets: [
                    { ...DEFAULT_WOD_MOVEMENT, movementId: 'burpee', movement: 'Burpee', category: 'bodyweight', reps: 10, unit: 'reps', time: 'Minuto par' },
                    { ...DEFAULT_WOD_MOVEMENT, movementId: 'kettlebell_swing', movement: 'Kettlebell Swing', category: 'kettlebell', reps: 15, unit: 'reps', load: '24/16 kg', time: 'Minuto ímpar' }
                ]}]
            }
        ]
    },
    // ── 5 NOVOS MODELOS PREMIUM DE WOD ──
    {
        id: 'sys_wod_5',
        title: 'WOD: Tabata Inferno (Bodyweight)',
        workoutType: 'wod',
        isSingleDay: true,
        weeklyFrequency: 1,
        totalWeeks: 1,
        workouts: [
            {
                name: 'Tabata 8 Rounds',
                blocks: [
                    { name: 'Aquecimento', workoutType: 'wod', componentType: 'warmup', sets: [
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'other', movement: 'Mobilidade articular', category: 'custom', reps: '', unit: 'reps', time: '3 min', notes: 'Quadril, ombros, tornozelos e coluna' },
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'air_squat', movement: 'Air Squat', category: 'bodyweight', reps: 10, unit: 'reps', notes: 'Ritmo leve' },
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'push_up', movement: 'Push-up', category: 'bodyweight', reps: 10, unit: 'reps' }
                    ]},
                    { name: 'WOD', workoutType: 'wod', componentType: 'metcon', format: 'tabata', scoreType: 'reps', timeCap: '16 min', stimulus: '20s de trabalho máximo + 10s de descanso. 8 rounds por exercício. Anotar menor round.', scalingNotes: 'RX: conforme descrito. Iniciante: reduzir para 4 rounds por exercício.', sets: [
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'air_squat', movement: 'Air Squat', category: 'bodyweight', reps: 'máx', unit: 'reps', time: '20s ON / 10s OFF', notes: 'Quadril abaixo do paralelo' },
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'push_up', movement: 'Push-up', category: 'bodyweight', reps: 'máx', unit: 'reps', time: '20s ON / 10s OFF', notes: 'Peito no chão a cada rep', scaling: { rx: 'Flexão completa', intermediate: 'Flexão no joelho', beginner: 'Flexão elevada' } },
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'burpee', movement: 'Burpee', category: 'bodyweight', reps: 'máx', unit: 'reps', time: '20s ON / 10s OFF', notes: 'Com salto e palma acima da cabeça' },
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'other', movement: 'Sit-up', category: 'bodyweight', reps: 'máx', unit: 'reps', time: '20s ON / 10s OFF' }
                    ]}
                ]
            }
        ]
    },
    {
        id: 'sys_wod_6',
        title: 'WOD: 5 RFT (Rounds For Time) com Scaling',
        workoutType: 'wod',
        isSingleDay: true,
        weeklyFrequency: 1,
        totalWeeks: 1,
        workouts: [
            {
                name: '5 Rounds For Time',
                blocks: [
                    { name: 'WOD', workoutType: 'wod', componentType: 'metcon', format: 'rft', scoreType: 'time', timeCap: '25 min', stimulus: 'Manter ritmo sustentável nos 5 rounds. Não sair rápido no round 1.', scalingNotes: 'RX: conforme descrito. Intermediário: 4 rounds e reduzir carga. Iniciante: 3 rounds sem carga.', sets: [
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'run', movement: 'Corrida', category: 'monostructural', reps: 400, unit: 'm', scaling: { rx: '400m', intermediate: '300m', beginner: '200m' } },
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'kettlebell_swing', movement: 'Kettlebell Swing', category: 'kettlebell', reps: 15, unit: 'reps', load: '24/16 kg', scaling: { rx: '24/16 kg', intermediate: '16/12 kg', beginner: '12/8 kg' } },
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'pull_up', movement: 'Pull-up', category: 'gymnastics', reps: 10, unit: 'reps', scaling: { rx: 'Strict ou kipping', intermediate: 'Banded', beginner: 'Ring row' } },
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'box_jump', movement: 'Box Jump', category: 'plyometric', reps: 15, unit: 'reps', height: '60/50 cm', scaling: { rx: '60/50 cm', intermediate: '50/40 cm', beginner: 'Step-up' } }
                    ]}
                ]
            }
        ]
    },
    {
        id: 'sys_wod_7',
        title: 'WOD: Ladder Crescente (Carga + Volume)',
        workoutType: 'wod',
        isSingleDay: true,
        weeklyFrequency: 1,
        totalWeeks: 1,
        workouts: [
            {
                name: 'Ladder 1-2-3-4-5-6-7-8-9-10',
                blocks: [
                    { name: 'WOD', workoutType: 'wod', componentType: 'metcon', format: 'ladder', scoreType: 'time', timeCap: '20 min', stimulus: 'Escalada progressiva de reps. Ritmo constante nos primeiros rounds, aceitar lentidão nos últimos. Objetivo: completar a sequência inteira dentro do time cap.', sets: [
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'deadlift', movement: 'Deadlift', category: 'strength', reps: '1-2-3-4-5-6-7-8-9-10', unit: 'reps', load: '100/70 kg', scaling: { rx: '100/70 kg', intermediate: '70/50 kg', beginner: '50/35 kg' } },
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'handstand_push_up', movement: 'Handstand Push-up', category: 'gymnastics', reps: '1-2-3-4-5-6-7-8-9-10', unit: 'reps', scaling: { rx: 'HSPU strict', intermediate: 'HSPU kipping', beginner: 'Pike push-up elevado' } }
                    ]}
                ]
            }
        ]
    },
    {
        id: 'sys_wod_8',
        title: 'WOD: Skill + Metcon (Dia Completo)',
        workoutType: 'wod',
        isSingleDay: true,
        weeklyFrequency: 1,
        totalWeeks: 1,
        workouts: [
            {
                name: 'Skill + Metcon',
                blocks: [
                    { name: 'Aquecimento', workoutType: 'wod', componentType: 'warmup', sets: [
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'row', movement: 'Remo', category: 'monostructural', reps: 500, unit: 'm', notes: 'Ritmo leve para aquecer' },
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'other', movement: 'PVC Pass-through', category: 'custom', reps: 15, unit: 'reps', notes: 'Mobilidade de ombro' }
                    ]},
                    { name: 'Skill', workoutType: 'wod', componentType: 'skill', format: 'skill', scoreType: 'quality', timeCap: '15 min', stimulus: 'Prática deliberada de habilidade ginástica. Foco na qualidade, não na velocidade.', sets: [
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'muscle_up', movement: 'Muscle-up', category: 'gymnastics', reps: '3-5', unit: 'reps', notes: 'EMOM 10 min: 3-5 muscle-ups por minuto. Se não tiver, praticar transição com elástico.', scaling: { rx: 'Muscle-up na argola', intermediate: 'Muscle-up com elástico', beginner: 'Transição negativa + pull-up' } }
                    ]},
                    { name: 'Força', workoutType: 'wod', componentType: 'strength', format: 'strength', scoreType: 'load', timeCap: '15 min', stimulus: 'Construir até carga pesada com técnica perfeita.', sets: [
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'clean', movement: 'Clean', category: 'weightlifting', reps: '5-3-3-1-1-1', unit: 'reps', load: 'Progressivo até 1RM', notes: 'Construir até 1RM técnico. Descanso 2-3 min entre séries pesadas.' }
                    ]},
                    { name: 'Metcon', workoutType: 'wod', componentType: 'metcon', format: 'amrap', scoreType: 'rounds_reps', timeCap: '8 min', stimulus: 'Curto e intenso. Não descansar mais de 5s entre movimentos.', sets: [
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'thruster', movement: 'Thruster', category: 'weightlifting', reps: 10, unit: 'reps', load: '60/40 kg', scaling: { rx: '60/40 kg', intermediate: '40/30 kg', beginner: '30/20 kg' } },
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'toes_to_bar', movement: 'Toes to Bar', category: 'gymnastics', reps: 10, unit: 'reps', scaling: { rx: 'T2B', intermediate: 'Knee raise', beginner: 'Hanging knee raise' } }
                    ]}
                ]
            }
        ]
    },
    {
        id: 'sys_wod_9',
        title: 'WOD: Interval Cardio Engine (Condicionamento)',
        workoutType: 'wod',
        isSingleDay: true,
        weeklyFrequency: 1,
        totalWeeks: 1,
        workouts: [
            {
                name: 'Interval 5x3min ON / 2min OFF',
                blocks: [
                    { name: 'Aquecimento', workoutType: 'wod', componentType: 'warmup', sets: [
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'bike', movement: 'Bike', category: 'monostructural', calories: 15, unit: 'cal', notes: 'Ritmo leve progressivo' },
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'other', movement: 'Inch Worm', category: 'bodyweight', reps: 8, unit: 'reps' },
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'air_squat', movement: 'Air Squat', category: 'bodyweight', reps: 15, unit: 'reps' }
                    ]},
                    { name: 'WOD', workoutType: 'wod', componentType: 'metcon', format: 'interval', scoreType: 'reps', timeCap: '25 min', stimulus: '5 rounds de 3 min de trabalho + 2 min de descanso completo. Anotar total de reps em cada round. Objetivo: manter consistência entre rounds.', sets: [
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'row', movement: 'Remo', category: 'monostructural', reps: 250, unit: 'm', notes: 'Sprint no remo' },
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'wall_ball', movement: 'Wall Ball', category: 'weightlifting', reps: 15, unit: 'reps', load: '9/6 kg', height: '3/2.7 m' },
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'double_under', movement: 'Double Under', category: 'monostructural', reps: 30, unit: 'reps', scaling: { rx: 'Double under', intermediate: 'Tentativa de DU', beginner: '60 single unders' } }
                    ]},
                    { name: 'Mobilidade', workoutType: 'wod', componentType: 'mobility', sets: [
                        { ...DEFAULT_WOD_MOVEMENT, movementId: 'other', movement: 'Alongamento de quadril e ombros', category: 'custom', reps: '', unit: 'reps', time: '5 min', notes: 'Foco em quadril, panturrilha e ombros. Respiração diafragmática.' }
                    ]}
                ]
            }
        ]
    },

    // ═══════════════════════════════════════════════════════════════
    // CORRIDA (5 Modelos premium)
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'sys_running_easy_base',
        title: 'Corrida: Rodagem Leve & Caminhada (Iniciante)',
        workoutType: 'running',
        isSingleDay: false,
        weeklyFrequency: 3,
        totalWeeks: 4,
        workouts: [
            {
                name: 'Treino Base - Transição',
                blocks: [
                    {
                        name: 'Aquecimento',
                        workoutType: 'running',
                        blockType: 'warmup',
                        sets: [
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'run', label: 'Trote preparatório Z1', durationType: 'time', duration: 5, targetType: 'effort', effortZone: 'z1', notes: 'Alternar passos curtos e soltos.' }
                        ]
                    },
                    {
                        name: 'Principal',
                        workoutType: 'running',
                        blockType: 'main',
                        repeat: 5,
                        restBetweenRepeats: '1min caminhada',
                        sets: [
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'run', label: '3min trote leve', durationType: 'time', duration: 3, targetType: 'effort', effortZone: 'z2', notes: 'Manter conversa confortável' },
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'walk', label: '2min caminhada', durationType: 'time', duration: 2, targetType: 'effort', effortZone: 'z1' }
                        ]
                    },
                    {
                        name: 'Soltura',
                        workoutType: 'running',
                        blockType: 'cooldown',
                        sets: [
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'walk', label: 'Caminhada solta final', durationType: 'time', duration: 5, targetType: 'effort', effortZone: 'z1', notes: 'Baixar frequência cardíaca' }
                        ]
                    }
                ]
            }
        ]
    },
    {
        id: 'sys_running_intervals_speed',
        title: 'Corrida: Tiros de Ritmo (Intervalado Curto)',
        workoutType: 'running',
        isSingleDay: false,
        weeklyFrequency: 3,
        totalWeeks: 6,
        workouts: [
            {
                name: 'Treino de Tiros',
                blocks: [
                    {
                        name: 'Aquecimento Plano',
                        workoutType: 'running',
                        blockType: 'warmup',
                        sets: [
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'run', label: '10min trote leve Z2', durationType: 'time', duration: 10, targetType: 'effort', effortZone: 'z2' }
                        ]
                    },
                    {
                        name: 'Educativos (Técnica)',
                        workoutType: 'running',
                        blockType: 'technique',
                        sets: [
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'drill', label: 'Skipping + Anfersen', durationType: 'time', duration: 5, targetType: 'effort', effortZone: 'z1', notes: 'Focar na postura e alta cadência' }
                        ]
                    },
                    {
                        name: 'Tiros de Velocidade',
                        workoutType: 'running',
                        blockType: 'intervals',
                        repeat: 8,
                        restBetweenRepeats: '90s trote leve',
                        sets: [
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'interval', label: 'Tiro de 400m', durationType: 'distance', distance: 400, distanceUnit: 'm', targetType: 'pace', targetPaceMin: "4:15", targetPaceMax: "4:30", effortZone: 'z5', notes: 'Ritmo forte de VO2max' }
                        ]
                    },
                    {
                        name: 'Desaquecimento',
                        workoutType: 'running',
                        blockType: 'cooldown',
                        sets: [
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'walk', label: 'Caminhada solta', durationType: 'time', duration: 5, targetType: 'effort', effortZone: 'z1' }
                        ]
                    }
                ]
            }
        ]
    },
    {
        id: 'sys_running_long_progressive',
        title: 'Corrida: Longão Progressivo (Ciclo de Prova)',
        workoutType: 'running',
        isSingleDay: false,
        weeklyFrequency: 4,
        totalWeeks: 12,
        workouts: [
            {
                name: 'Longo de Resistência',
                cyclePlan: {
                    enabled: true,
                    raceName: "Maratona do Rio",
                    raceDate: "2026-10-12",
                    raceDistance: "42.195 km",
                    weekNumber: "8",
                    totalWeeks: "12",
                    phase: "specific",
                    plannedWeeklyKm: "65",
                    notes: "Simular alimentação e hidratação de prova durante o treino."
                },
                blocks: [
                    {
                        name: 'Principal Progressivo',
                        workoutType: 'running',
                        blockType: 'main',
                        sets: [
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'run', label: '8km Leve Z2', durationType: 'distance', distance: 8, distanceUnit: 'km', targetType: 'effort', effortZone: 'z2', notes: 'Ritmo confortável de base' },
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'run', label: '5km Ritmo Maratona Z3', durationType: 'distance', distance: 5, distanceUnit: 'km', targetType: 'effort', effortZone: 'z3', notes: 'Ritmo firme planejado de prova' },
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'run', label: '2km Ritmo Meia Maratona Z4', durationType: 'distance', distance: 2, distanceUnit: 'km', targetType: 'effort', effortZone: 'z4', notes: 'Forte sustentável no final' },
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'cooldown', label: '1km Desaquecimento', durationType: 'distance', distance: 1, distanceUnit: 'km', targetType: 'effort', effortZone: 'z1' }
                        ]
                    }
                ]
            }
        ]
    },
    {
        id: 'sys_running_fartlek_tempo',
        title: 'Corrida: Fartlek Sueco (Tempo Variado)',
        workoutType: 'running',
        isSingleDay: false,
        weeklyFrequency: 3,
        totalWeeks: 8,
        workouts: [
            {
                name: 'Fartlek Estruturado',
                blocks: [
                    {
                        name: 'Aquecimento',
                        workoutType: 'running',
                        blockType: 'warmup',
                        sets: [
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'run', label: '2km trote leve', durationType: 'distance', distance: 2, distanceUnit: 'km', targetType: 'effort', effortZone: 'z2' }
                        ]
                    },
                    {
                        name: 'Fartlek de Tempo',
                        workoutType: 'running',
                        blockType: 'main',
                        sets: [
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'interval', label: '3min ritmo forte Z4', durationType: 'time', duration: 3, targetType: 'effort', effortZone: 'z4' },
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'recovery', label: '2min trote leve Z2', durationType: 'time', duration: 2, targetType: 'effort', effortZone: 'z2' },
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'interval', label: '2min ritmo forte Z4', durationType: 'time', duration: 2, targetType: 'effort', effortZone: 'z4' },
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'interval', label: '1min tiro Z5', durationType: 'time', duration: 1, targetType: 'effort', effortZone: 'z5', notes: 'Aceleração máxima' },
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'recovery', label: '2min trote leve Z2', durationType: 'time', duration: 2, targetType: 'effort', effortZone: 'z2' },
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'interval', label: '3min ritmo forte Z4', durationType: 'time', duration: 3, targetType: 'effort', effortZone: 'z4' }
                        ]
                    },
                    {
                        name: 'Soltura',
                        workoutType: 'running',
                        blockType: 'cooldown',
                        sets: [
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'walk', label: '1km caminhada solta', durationType: 'distance', distance: 1, distanceUnit: 'km', targetType: 'effort', effortZone: 'z1' }
                        ]
                    }
                ]
            }
        ]
    },
    {
        id: 'sys_running_club_hills',
        title: 'Corrida: Tiros em Subida (Treino de Clube)',
        workoutType: 'running',
        isSingleDay: false,
        weeklyFrequency: 3,
        totalWeeks: 4,
        workouts: [
            {
                name: 'Tiros na Ladeira',
                clubSession: {
                    isClubSession: true,
                    teamName: "Neo Runners Club",
                    coachName: "Treinador Rodrigo",
                    meetingPoint: "Ladeira Principal do Parque",
                    startTime: "06:30",
                    routeName: "Tiros na ladeira de 150m inclinada",
                    safetyNotes: "Subida com força máxima, descida caminhando para preservar articulações. Beber água na base.",
                    paceGroups: [
                        { id: "g1", label: "G1", desc: "Avançado", easyPace: "5:00-5:40", thresholdPace: "4:20-4:45", intervalPace: "4:00-4:20", longRunPace: "5:20-6:00", enabled: true },
                        { id: "g2", label: "G2", desc: "Intermediário", easyPace: "5:50-6:30", thresholdPace: "5:05-5:30", intervalPace: "4:45-5:05", longRunPace: "6:10-6:50", enabled: true },
                        { id: "g3", label: "G3", desc: "Iniciante", easyPace: "6:40-7:30", thresholdPace: "5:50-6:20", intervalPace: "5:30-5:50", longRunPace: "7:00-8:00", enabled: true }
                    ]
                },
                blocks: [
                    {
                        name: 'Aquecimento Plano',
                        workoutType: 'running',
                        blockType: 'warmup',
                        sets: [
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'run', label: '15min trote plano leve Z2', durationType: 'time', duration: 15, targetType: 'effort', effortZone: 'z2' }
                        ]
                    },
                    {
                        name: 'Tiros na Ladeira',
                        workoutType: 'running',
                        blockType: 'intervals',
                        repeat: 8,
                        restBetweenRepeats: 'Volta caminhando',
                        sets: [
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'hill', label: '30s subida forte Z5', durationType: 'time', duration: 0.5, targetType: 'effort', effortZone: 'z5', terrain: 'hill', notes: 'Focar na força das passadas e no uso dos braços' },
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'recovery', label: 'Descida caminhando Z1', durationType: 'open', targetType: 'effort', effortZone: 'z1', terrain: 'hill' }
                        ]
                    },
                    {
                        name: 'Desaquecimento',
                        workoutType: 'running',
                        blockType: 'cooldown',
                        sets: [
                            { ...DEFAULT_RUNNING_SEGMENT, segmentType: 'walk', label: '5min caminhada plana', durationType: 'time', duration: 5, targetType: 'effort', effortZone: 'z1' }
                        ]
                    }
                ]
            }
        ]
    }
];
